'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _boardService = require('../element/board/boardService');

var _elementConstants = require('../../common/elements/elementConstants');

exports.default = function (store) {
    return function (next) {
        return function (action) {
            if (action.type !== _elementConstants.ELEMENT_FORCE_LOAD) return next(action);

            store.dispatch((0, _boardService.fetchBoard)({
                boardId: action.id,
                force: true,
                excludeSelf: true,
                loadNextBoards: true,
                loadAncestors: false
            }));

            return next(action);
        };
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/store/forceElementLoadMiddleware.js
// module id = 2051
// module chunks = 0